
export default {
  name: "Register",
  data() {
    return {
      newAccount: {
        brandName: "",
        companyName: "",
        email: "",
        name: "",
        password: "",
        phoneNumber: "",
      },
      showSuccessPopup: false,
    };
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    onClickHeaderReturn() {
      this.$router.go(-1);
    },
    onClickConfirm() {
      if (this.$utils.isNullAndEmpty(this.newAccount.email)) {
        this.$toast({
          type: "fail",
          duration: "2000",
          position: "middle",
          message: "Please enter your E-mail.",
        });
        return;
      }
      if (this.$utils.isNullAndEmpty(this.newAccount.password)) {
        this.$toast({
          type: "fail",
          duration: "2000",
          position: "middle",
          message: "Please enter login password.",
        });
        return;
      }
      if (this.newAccount.password.length < 6) {
        this.$toast({
          type: "fail",
          duration: "2000",
          position: "middle",
          message: "Login password length cannot be less than 6 digits",
        });
        return;
      }
      this.$api.user.registerBrandUser(this.newAccount).then((res) => {
        if (res.code == 200) {
          this.showSuccessPopup = true;
        } else {
          this.$toast({
            type: "fail",
            duration: "2000",
            position: "middle",
            message: res.message,
          });
        }
      });
    },
    onClickOk() {
      this.$router.go(-1);
    },
  },
};
